
export class CurrentPositionDataModel {
    public account = '';

    public sharesCountText = '';

    public sharesPnLText = '';
    public sharesPnLColor = '';

    constructor(currentPositionData?: any) {
        if (currentPositionData) {
            this.account = currentPositionData.account;

            this.sharesCountText = currentPositionData.sharesCountText;

            this.sharesPnLText = currentPositionData.sharesPnLText;
            this.sharesPnLColor = currentPositionData.sharesPnLColor;
        }
    }

    public hasValue(): boolean {
        return !!this.sharesCountText;
    }

    public doesNotHaveValue(): boolean {
        return !this.hasValue();
    }

    public toHtml(): string {
        return `
        <div class="current-position-container" title="${this.account}">
            <div class="shares-count">${this.sharesCountText}</div>
            <div class="shares-pnl" style="color: ${this.sharesPnLColor};">${this.sharesPnLText}</div>
        </div>`;
    }
}
